import { render, staticRenderFns } from "./lyb.vue?vue&type=template&id=f82f155c&scoped=true&"
import script from "./lyb.vue?vue&type=script&lang=js&"
export * from "./lyb.vue?vue&type=script&lang=js&"
import style0 from "./lyb.vue?vue&type=style&index=0&id=f82f155c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82f155c",
  null
  
)

export default component.exports